var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "bg-grey-1" },
    [
      _c(
        "q-card-media",
        {
          class: _vm.trail.is_blocked ? "disable-image" : "",
          nativeOn: {
            click: function($event) {
              return _vm.goToTrail()
            }
          }
        },
        [
          _vm.trail.image_small
            ? _c("img", { attrs: { src: _vm.trail.image_small } })
            : _vm._e(),
          !_vm.trail.image_small
            ? _c("img", { attrs: { src: _vm.getPlaceholder } })
            : _vm._e()
        ]
      ),
      _c(
        "q-card-main",
        {
          staticClass: "relative-position",
          nativeOn: {
            click: function($event) {
              return _vm.goToTrail()
            }
          }
        },
        [
          _c("div", { staticClass: "line-card bg-primary absolute-top" }),
          _c("div", { staticClass: "row q-my-sm" }, [
            _c("div", { staticClass: "col-10" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-12 q-title text-weight-medium",
                    class: _vm.trail.is_blocked ? "text-faded" : "text-primary"
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.trail.title) +
                        "\n                    "
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-12 q-mb-md" },
                  [
                    _c("q-rating", {
                      attrs: {
                        slot: "subtitle",
                        color: "amber",
                        icon: "fas fa-star",
                        max: 5,
                        readonly: ""
                      },
                      slot: "subtitle",
                      model: {
                        value: _vm.trail.stars,
                        callback: function($$v) {
                          _vm.$set(_vm.trail, "stars", $$v)
                        },
                        expression: "trail.stars"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "col-2 text-center" },
              [
                _c(
                  "vc-donut",
                  { attrs: { sections: _vm.sections, size: 100, unit: "%" } },
                  [
                    _vm.trail.user_trail_progress < 100 &&
                    _vm.trail.trail_user_result_status != 2
                      ? _c(
                          "h6",
                          {
                            class: _vm.trail.is_blocked
                              ? "text-faded"
                              : "text-primary"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.getPercentage(
                                    _vm.trail.user_trail_progress
                                  )
                                ) +
                                "%\n                    "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.trail.user_trail_progress == 100 ||
                    _vm.trail.trail_user_result_status == 2
                      ? _c("q-icon", {
                          attrs: {
                            name: _vm.getResult,
                            color: _vm.getResultColor,
                            size: "1.5rem"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c("div", { staticClass: "col-6" }, [
                  _vm.trail.areas.length > 0
                    ? _c("p", { staticClass: "caption" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("areas")) +
                            "\n                        "
                        )
                      ])
                    : _vm._e(),
                  _vm.trail.areas.length > 0
                    ? _c(
                        "p",
                        { staticClass: "tooltip q-mb-sm" },
                        _vm._l(_vm.trail.areas, function(area, index) {
                          return _c("span", { key: index }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.getArea(area))
                            ),
                            _vm.trail.areas.length - 1 > index
                              ? _c("span", [_vm._v(", ")])
                              : _vm._e()
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm.trail.user_groups.length > 0
                    ? _c("p", { staticClass: "caption" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("groups")) +
                            "\n                        "
                        )
                      ])
                    : _vm._e(),
                  _vm.trail.user_groups.length > 0
                    ? _c(
                        "p",
                        { staticClass: "tooltip q-mb-sm" },
                        _vm._l(_vm.trail.user_groups, function(group, index) {
                          return _c("span", { key: index }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.getGroup(group))
                            ),
                            _vm.trail.user_groups.length - 1 > index
                              ? _c("span", [_vm._v(", ")])
                              : _vm._e()
                          ])
                        }),
                        0
                      )
                    : _vm._e()
                ]),
                _c("div", { staticClass: "col-6" }, [
                  _vm.trail.tags.length > 0
                    ? _c("p", { staticClass: "caption" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("tags")) +
                            "\n                        "
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "p",
                    { staticClass: "tooltip q-mb-sm" },
                    _vm._l(_vm.trail.tags, function(tag, index) {
                      return _c("span", { key: index }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.getTag(tag))
                        ),
                        _vm.trail.tags.length - 1 > index
                          ? _c("span", [_vm._v(", ")])
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                ]),
                _vm.trail.is_blocked && _vm.trail.trail_parent_title
                  ? _c("div", { staticClass: "col-12 q-mt-md" }, [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("requirements")) +
                            "\n                        "
                        )
                      ]),
                      _c("p", { staticClass: "tooltip" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.trail.trail_parent_title) +
                            "\n                        "
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ]
      ),
      _c("q-card-separator"),
      _vm.actions.length > 0
        ? _c("q-card-actions", [
            _c(
              "p",
              { staticClass: "text-center fit" },
              _vm._l(_vm.actions, function(action, index) {
                return _c(
                  "q-btn",
                  {
                    key: index,
                    attrs: {
                      flat: "",
                      icon: action.icon,
                      color: "primary",
                      label: _vm.getLabel(action.label),
                      color: _vm.getColor(action.slug)
                    },
                    on: {
                      click: function($event) {
                        return _vm.doAction(action.slug)
                      }
                    }
                  },
                  [
                    action.tooltip
                      ? _c("q-tooltip", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t(action.tooltip)) +
                              "\n                "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              }),
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }